import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';
import css_248z from './main-categories-item-updated.scss.js';
import { validateButtonLabel, validateTitle, validateDescription } from './utils.js';

class MainCategoriesItemUpdated extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.index = 0;
        this.hasDivider = false;
        this.idPrefix = 'main-categories';
    }
    renderCtaButton() {
        var _a, _b;
        if (!((_a = this.item.ctaButton) === null || _a === void 0 ? void 0 : _a.url)) {
            return w;
        }
        const ctaButtonLabel = validateButtonLabel(this.item.ctaButton.title || '');
        const ctaButtonHref = this.item.ctaButton.url;
        const ctaButtonTarget = this.item.ctaButton.target || '_self';
        const ariaListValue = ((_b = this.item.ctaButton.ariaLabel) === null || _b === void 0 ? void 0 : _b.trim())
            ? { label: this.item.ctaButton.ariaLabel }
            : {};
        return $ `<generic-button-updated type="tertiary" color="purple" .label="${ctaButtonLabel}" .href="${ctaButtonHref}" .target="${ctaButtonTarget}" .ariaList="${ariaListValue}" ?isNoFollow="${this.item.ctaButton.isNoFollow || false}" ?rtl="${false}" class="category-cta"></generic-button-updated>`;
    }
    render() {
        const validatedTitle = validateTitle(this.item.title);
        const validatedDescription = validateDescription(this.item.description);
        const titleId = `${this.idPrefix}-card-title-${this.index}`;
        const articleId = `${this.idPrefix}-card-${this.index}`;
        const itemIndexClass = this.hasDivider ? `item-${this.index}` : '';
        const dividerClass = this.hasDivider ? 'divider' : '';
        const rtlClass = this.rtl || isRTL() ? 'rtl' : '';
        const categoryItemClasses = `category-item ${dividerClass} ${itemIndexClass} ${rtlClass}`;
        return $ `<article class="${categoryItemClasses}" aria-labelledby="${titleId}" id="${articleId}"><div class="image-wrapper"><generic-image src="${this.item.image.src}" alt="${this.item.image.altText}" aspect-ratio="4:3" loading="lazy"></generic-image></div><div class="text-content"><h3 id="${titleId}" class="category-title">${o(validatedTitle)}</h3><p class="category-description">${o(validatedDescription)}</p>${this.renderCtaButton()}</div></article>`;
    }
}
MainCategoriesItemUpdated.styles = css_248z;
__decorate([
    e({ type: Object })
], MainCategoriesItemUpdated.prototype, "item", void 0);
__decorate([
    e({ type: Boolean })
], MainCategoriesItemUpdated.prototype, "rtl", void 0);
__decorate([
    e({ type: Number })
], MainCategoriesItemUpdated.prototype, "index", void 0);
__decorate([
    e({ type: Boolean })
], MainCategoriesItemUpdated.prototype, "hasDivider", void 0);
__decorate([
    e({ type: String })
], MainCategoriesItemUpdated.prototype, "idPrefix", void 0);
customElements.define('main-categories-item-updated', MainCategoriesItemUpdated);

export { MainCategoriesItemUpdated };
